'use strict';

var customerModule = angular.module('t2g.customer', [
  'gettext',
  'ngFileUpload',
  'ui.router',
  require('t2g.common.data-access.customer').name,
  require('t2g.common.services.industrySpecificService').name,
  require('t2g.common.services.modalService').name,
  require('t2g.common.services.notificationService').name,
  require('t2g.common.services.sessionStorage').name,
]);

module.exports = customerModule;

customerModule.controller('CustomerProfileCtrl', require('./profile/CustomerProfileCtrl'));
customerModule.controller('CustomerUploadCtrl', require('./upload/CustomerUploadCtrl'));
customerModule.controller('CustomerListCtrl', require('./CustomerListCtrl'));

customerModule.config(function($stateProvider) {
  $stateProvider
    .state('private.main.customer', {
      url: '/customers',
      title: 'Customers',
      templateUrl: '/app/modules/customer/list.html?v=4.5.6',
      controller: 'CustomerListCtrl as CustomerListCtrl',
      resolve: {
        customers: function(CustomerDA) {
          return CustomerDA.list();
        },
      },
    })
    .state('private.main.customerUpload', {
      url: '/customerUpload',
      title: 'Customers',
      templateUrl: '/app/modules/customer/upload/CustomerUploadView.html?v=4.5.6',
      controller: 'CustomerUploadCtrl',
    })
    .state('private.main.customerProfile', {
      url: '/customers/:customerId?referrer',
      title: 'Customers',
      templateUrl: '/app/modules/customer/profile/partial-customer-profile.html?v=4.5.6',
      controller: 'CustomerProfileCtrl',
      resolve: {
        customer: function($stateParams, CustomerDA) {
          if ($stateParams.customerId && $stateParams.customerId !== 'new') {
            return CustomerDA.get($stateParams.customerId);
          } else {
            return {};
          }
        },
        filteredCustomers: function(CustomerDA) {
          return CustomerDA.getFiltered();
        },
        office: function(OfficeDA) {
          return OfficeDA.get();
        },
        resources: function(ResourceDA) {
          return ResourceDA.list('employee').then(function(employees) {
            return _.keyBy(employees.resources, '_id');
          });
        },
        services: function($q, OfficeModel) {
          var deferred = $q.defer();
          var services = [];

          OfficeModel.get(function(error, office) {
            if (error) {
              deferred.reject(error);
            } else {
              _.forEach(office.serviceGroups, function(group) {
                _.forEach(group.services, function(service) {
                  service.group = group.name;
                });

                services = services.concat(group.services);
              });

              deferred.resolve(services);
            }
          });

          return deferred.promise;
        },
        invoices: function($stateParams, AccountingDA) {
          if ($stateParams.customerId && $stateParams.customerId !== 'new') {
            return AccountingDA.getForCustomer($stateParams.customerId);
          } else {
            return [];
          }
        },
      },
    });
});



// WEBPACK FOOTER //
// ./src/app/modules/customer/customerModule.js